var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScheduleIcon = function SvgScheduleIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-schedule",
    d: "M3.833,0A3.833,3.833,0,1,0,7.667,3.833,3.841,3.841,0,0,0,3.833,0Zm0,1A2.833,2.833,0,1,1,1,3.833,2.826,2.826,0,0,1,3.833,1Zm-.008.66a.5.5,0,0,0-.492.507V3.833a.5.5,0,0,0,.147.354l.667.667a.5.5,0,1,0,.707-.707l-.52-.52V2.167a.5.5,0,0,0-.508-.507ZM7.94,2a4.452,4.452,0,0,1,.313,1h3.58A1.168,1.168,0,0,1,13,4.167v.5H8.253a4.487,4.487,0,0,1-.313,1H13v6.167A1.168,1.168,0,0,1,11.833,13H4.167A1.168,1.168,0,0,1,3,11.833V8.253A4.487,4.487,0,0,1,2,7.94v3.893A2.169,2.169,0,0,0,4.167,14h7.667A2.169,2.169,0,0,0,14,11.833V4.167A2.169,2.169,0,0,0,11.833,2ZM8,7a.833.833,0,1,0,.833.833A.833.833,0,0,0,8,7Zm2.833,0a.833.833,0,1,0,.833.833A.833.833,0,0,0,10.833,7ZM5.167,10A.833.833,0,1,0,6,10.833.833.833,0,0,0,5.167,10ZM8,10a.833.833,0,1,0,.833.833A.833.833,0,0,0,8,10Z",
    fill: "#6a7888"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScheduleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scheduleIcon.756f8a10.svg";
export { ForwardRef as ReactComponent };